import React from 'react'
import { Helmet } from 'react-helmet'
import { Redirect, Route, Switch } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import Sidebar from './components/Sidebar/Sidebar'
import Band from './components/Band/Band'
import { getMenuItemsByProject } from './menu'

import { API__PROJECTS } from '../../api'
import Loader from '../../common/components/Loader/Loader'

import './ProjectAnalytics.scss'

import DashboardLayout from './layouts/Dashboard/Dashboard'
import GeographyLayout from './layouts/Geography/Geography'
import BlocksLayout from './layouts/Blocks/Blocks'

class ProjectAnalytics extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isReady: false,
            project: null,
            menuItems: null,
        }
    }

    async componentDidMount() {
        const {
            params: { id },
            url,
        } = this.props.match

        const project = await API__PROJECTS.GET_PROJECT(id)

        this.setState({
            project,
            menuItems: getMenuItemsByProject(url, project),
            isReady: true,
        })
    }

    render() {
        const {
            location: { pathname },
            match: {
                params: { id },
            },
            t,
        } = this.props
        const { isReady, project, menuItems } = this.state

        return (
            <div className="project-analytics">
                <Helmet>
                    <title>{t('Project analytics')} | Interacty</title>
                </Helmet>
                {isReady ? (
                    <>
                        <Band backPath={`/account/my-projects?tab=published`} projectName={project.name} />
                        <div className="project-analytics__workplace">
                            <Sidebar menuItems={menuItems} activePathname={pathname} />
                            <div className="project-analytics-content">
                                <div className="project-analytics-content__inner">
                                    <Switch>
                                        <Route
                                            exact
                                            path="/account/my-projects/:projectId/analytics"
                                            render={() => <DashboardLayout project={project} />}
                                        />
                                        <Route
                                            exact
                                            path="/account/my-projects/:projectId/analytics/geography"
                                            render={() => <GeographyLayout project={project} />}
                                        />
                                        <Route
                                            exact
                                            path="/account/my-projects/:projectId/analytics/blocks/:blockId"
                                            render={() => <BlocksLayout project={project} />}
                                        />
                                        <Redirect from="*" to={`/account/my-projects/${id}/analytics`} />
                                    </Switch>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <Loader />
                )}
            </div>
        )
    }
}

export default withTranslation('translations')(ProjectAnalytics)
